<template>
  <v-dialog width="300px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>Cancelar recorrência</strong>
      </v-card-title>

      <v-card-text>
        <v-container v-if="cobrarMulta === true">
          <v-row justify="center">
            <v-col sm="12"
              ><strong style="color: #c43d4b">CUIDADO!</strong></v-col
            >
          </v-row>
          <v-row>
            <v-col sm="12">
              Essa recorrência ainda está em prazo de carência, será cobrado o
              valor de
              <strong>R$ {{ recurrentCancelMulctValue / 100 }}</strong>
              referente a multa por cancelamento antes do prazo, deseja
              continuar?
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="12">
              <v-checkbox
                v-model="checkboxMulta"
                label="Cobrar multa"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row>
            <v-col sm="12"
              ><strong>Deseja cancelar essa recorrência?</strong></v-col
            >
          </v-row>
          <v-row>
            <v-col sm="12">
              Nenhuma multa será aplicada!
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="text-center align-center">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="hideModal">
          NÃO
        </v-btn>
        <v-btn color="green darken-1" @click="salvar">
          SIM
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    recurrent: Object,
    cobrarMulta: Boolean,
    recurrentCancelMulctValue: Number,
  },
  data() {
    return {
      checkboxMulta: true,
    };
  },
  methods: {
    salvar() {
      if (this.cobrarMulta) this.$emit('btnSalvar', this.checkboxMulta);
      else this.$emit('btnSalvar', false);
    },
    hideModal() {
      this.$emit('btnNao');
    },
  },
};
</script>
